/**
 * Google Analytics loader
 */

require("./ga4/loader")
